class LineItemModel extends App.Models.BaseModel {
    modelUrl = 'LineItem';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.LineItem = LineItemModel;
